function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import { get } from '../../utils';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import FunFactsItem, { commonStyles, rtlStyles, ltrStyles } from '../21_FunFactsItem/FunFactItem';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useInView } from 'react-intersection-observer';
import { convertToAnalyticObject } from '../../utils/analytics';
export const FunFactsContainer = _ref => {
  let {
    fields,
    rendering,
    params
  } = _ref;
  const [ref, inView] = useInView({
    rootMargin: '100px 0px 100px 0px',
    triggerOnce: true
  });
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const title = get(fields, 'data.item.title.jss');
  const titleContainer = get(title, 'value');
  const showNumber = get(fields, 'data.item.showNumber.jss') || false;
  const placeholdersItems = get(rendering, 'placeholders.funfacts-container');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  if (!fields) {
    console.warn('FunFactsContainer component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [FunFactsContainer component is empty: please provide data source]");
    }
    return null;
  }
  const renderItems = () => {
    if (placeholdersItems) {
      return placeholdersItems.map((item, index) => /*#__PURE__*/React.createElement(FunFactsItem, {
        key: item.uid,
        showNumber: showNumber,
        index: index,
        inView: inView,
        titleContainer: titleContainer,
        fields: _objectSpread({}, item.fields),
        params: {
          params
        },
        oneItem: !(placeholdersItems.length > 1)
      }));
    }
    return [];
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, !pageEditing ? /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: `facts__navigation ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['prevNavAnalytics'], params))), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextNavAnalytics'], params)))), renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      }
    }, () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['mobileSlidesAnalytics'], params))), renderDots(() => {
      renderDots(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params)));
    }));
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    field: title
  }), /*#__PURE__*/React.createElement(Placeholder, {
    name: "funfacts-container",
    rendering: rendering
  })));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default FunFactsContainer;